// src/components/sections/ConfigToggle.js

import React from 'react';

const ConfigToggle = ({ label, description, checked, onChange }) => (
  <div className="flex items-start justify-between py-4">
    <div className="flex-grow pr-4">
      <div className="font-medium text-gray-900">{label}</div>
      <div className="text-sm text-gray-500">{description}</div>
    </div>
    <div className="flex-shrink-0">
      <button
        type="button"
        role="switch"
        aria-checked={checked}
        onClick={() => onChange(!checked)}
        className={`
          relative inline-flex h-6 w-11 flex-shrink-0 cursor-pointer rounded-full border-2 
          border-transparent transition-colors duration-200 ease-in-out focus:outline-none 
          focus:ring-2 focus:ring-violet-500 focus:ring-offset-2
          ${checked ? 'bg-violet-600' : 'bg-gray-200'}
        `}
      >
        <span
          className={`
            pointer-events-none inline-block h-5 w-5 transform rounded-full bg-white shadow 
            ring-0 transition duration-200 ease-in-out
            ${checked ? 'translate-x-5' : 'translate-x-0'}
          `}
        />
      </button>
    </div>
  </div>
);

export default ConfigToggle;
